import { CommonEnums } from '../../common.enums';

export class RDesign_Inst {
    rDesign_Inst_Id: number;
    dxMp_Id: number;
    rdxMp_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    persistFlg: string;
    updateBy: string;
    updateDt: Date;
    gen_Tab_Valid_Cd: string;
    outmapr_Tab_Valid_Cd: string;
    inmapr_Tab_Valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.rDesign_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.rdxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.persistFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.gen_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.outmapr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.inmapr_Tab_Valid_Cd = CommonEnums.defaults.SUCCESS_CODE;
    }

    static parse(object: any): RDesign_Inst {   // Constant method that is the same for every instance of a class.
        let rDesign_Inst: RDesign_Inst = new RDesign_Inst();
        rDesign_Inst.copyFrom(object as RDesign_Inst);
        return rDesign_Inst;
    }


    copy(): RDesign_Inst {
        let rDesign_InstTmp: RDesign_Inst = new RDesign_Inst();

        rDesign_InstTmp.rDesign_Inst_Id = this.rDesign_Inst_Id;
        rDesign_InstTmp.dxMp_Id = this.dxMp_Id;
        rDesign_InstTmp.rdxMp_Id = this.rdxMp_Id;
        rDesign_InstTmp.nm = this.nm;
        rDesign_InstTmp.description = this.description;
        rDesign_InstTmp.ver = this.ver;
        rDesign_InstTmp.valid_Cd = this.valid_Cd;
        rDesign_InstTmp.persistFlg = this.persistFlg;
        rDesign_InstTmp.updateBy = this.updateBy;
        rDesign_InstTmp.updateDt = this.updateDt;
        rDesign_InstTmp.gen_Tab_Valid_Cd = this.gen_Tab_Valid_Cd;
        rDesign_InstTmp.outmapr_Tab_Valid_Cd = this.outmapr_Tab_Valid_Cd;
        rDesign_InstTmp.inmapr_Tab_Valid_Cd = this.inmapr_Tab_Valid_Cd;

        return rDesign_InstTmp;
    }

    copyFrom(rDesign_InstTmp: RDesign_Inst): void {
        this.rDesign_Inst_Id = rDesign_InstTmp.rDesign_Inst_Id;
        this.dxMp_Id = rDesign_InstTmp.dxMp_Id;
        this.rdxMp_Id = rDesign_InstTmp.rdxMp_Id;
        this.nm = rDesign_InstTmp.nm;
        this.description = rDesign_InstTmp.description;
        this.ver = rDesign_InstTmp.ver;
        this.valid_Cd = rDesign_InstTmp.valid_Cd;
        this.persistFlg = rDesign_InstTmp.persistFlg;
        this.updateBy = rDesign_InstTmp.updateBy;
        this.updateDt = rDesign_InstTmp.updateDt;
        this.gen_Tab_Valid_Cd = rDesign_InstTmp.gen_Tab_Valid_Cd;
        this.outmapr_Tab_Valid_Cd = rDesign_InstTmp.outmapr_Tab_Valid_Cd;
        this.inmapr_Tab_Valid_Cd = rDesign_InstTmp.inmapr_Tab_Valid_Cd;
    }

    compare(rDesign_InstTmp: RDesign_Inst): string {
        let rDesign_InstString: string = this.toString(false);
        let rDesign_InstTmpString: string = rDesign_InstTmp.toString(false);

        if (rDesign_InstString != rDesign_InstTmpString) {
            return rDesign_InstString + ', ' + rDesign_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "RDesign_Inst [rDesign_Inst_Id=" + this.rDesign_Inst_Id + ", dxMp_Id=" + this.dxMp_Id +
            ", rdxMp_Id=" + this.rdxMp_Id + ", nm=" + this.nm + ", description=" + this.description +
            ", ver=" + this.ver + ", valid_Cd=" + this.valid_Cd + ", persistFlg=" + this.persistFlg +
            ", updateBy=" + this.updateBy + ", updateDt=" + this.updateDt + ", gen_Tab_Valid_Cd=" + this.gen_Tab_Valid_Cd +
            ", outmapr_Tab_Valid_Cd=" + this.outmapr_Tab_Valid_Cd + ", inmapr_Tab_Valid_Cd=" + this.inmapr_Tab_Valid_Cd + "]";

        if (isNotCompare) {
            str += ''
        }

        str += ']';
        return str;
    }
}

